/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PriceTableQuery = {
    paymentType?: PriceTableQuery.paymentType;
    ticketFormat?: PriceTableQuery.ticketFormat;
    tariffZoneNumber?: number;
    /**
     * Tariff number or name.
     */
    tariff?: string;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
    /**
     * Sort by. Default: id
     */
    sortBy?: string;
    /**
     * Sort order descendent. Default: true
     */
    sortDesc?: boolean;
    /**
     * Sort with locale. Default: sk
     */
    sortLocale?: string;
    /**
     * Page Size. Default: 25
     */
    limit?: number;
    /**
     * Offsetting x items. Default: 0
     */
    offset?: number;
    validOnly?: boolean;
};
export namespace PriceTableQuery {
    export enum paymentType {
        CASH = 'CASH',
        EMV = 'EMV',
    }
    export enum ticketFormat {
        IDENTIFIER = 'IDENTIFIER',
        MOBILE = 'MOBILE',
        QR = 'QR',
        PAPER = 'PAPER',
    }
}

